import Can from '@assets/icons/software_specializations/can.svg?react';
import Ignition from '@assets/icons/software_specializations/ignition_iot.svg?react';
import { ISoftwareIntegratorDto, TSoftwareSpecialization } from '@softwareIntegrator/types/softwareIntegrator';

import AI from '@assets/icons/software_specializations/ai.svg?react';
import Arduino from '@assets/icons/software_specializations/arduino.svg?react';
import CANBus from '@assets/icons/software_specializations/canbus.svg?react';
import Commissioning from '@assets/icons/software_specializations/commissioning.svg?react';
import CPlusPlus from '@assets/icons/software_specializations/cpp.svg?react';
import CSharp from '@assets/icons/software_specializations/csharp.svg?react';
import Default from '@assets/icons/software_specializations/default.svg?react';
import Docker from '@assets/icons/software_specializations/docker.svg?react';
import Grafana from '@assets/icons/software_specializations/grafana.svg?react';
import HomeAssistant from '@assets/icons/software_specializations/home_assistant.svg?react';
import Influx from '@assets/icons/software_specializations/influx.svg?react';
import IoBroker from '@assets/icons/software_specializations/io_broker.svg?react';
import IoT from '@assets/icons/software_specializations/iot.svg?react';
import Javascript from '@assets/icons/software_specializations/javascript.svg?react';
import LoRa from '@assets/icons/software_specializations/lora.svg?react';
import MachineLearning from '@assets/icons/software_specializations/machine_learning.svg?react';
import MarineApplication from '@assets/icons/software_specializations/marine_application.svg?react';
import Microcontrollers from '@assets/icons/software_specializations/microcontrollers.svg?react';
import Milestone from '@assets/icons/software_specializations/milestone_xprotect.svg?react';
import Modbus from '@assets/icons/software_specializations/modbus.svg?react';
import MQTT from '@assets/icons/software_specializations/mqtt.svg?react';
import MySQL from '@assets/icons/software_specializations/mysql.svg?react';
import Nginx from '@assets/icons/software_specializations/nginx.svg?react';
import NmeaToVictron from '@assets/icons/software_specializations/nmea_to_victron.svg?react';
import NodeRed from '@assets/icons/software_specializations/node_red.svg?react';
import PHP from '@assets/icons/software_specializations/php.svg?react';
import PLC from '@assets/icons/software_specializations/plc.svg?react';
import Postgresql from '@assets/icons/software_specializations/postgresql.svg?react';
import Proxmox from '@assets/icons/software_specializations/proxmox.svg?react';
import Python from '@assets/icons/software_specializations/python.svg?react';
import RaspberryPi from '@assets/icons/software_specializations/raspberry_pi.svg?react';
import Reactjs from '@assets/icons/software_specializations/reactjs.svg?react';
import RVC from '@assets/icons/software_specializations/rvc.svg?react';
import Scada from '@assets/icons/software_specializations/scada.svg?react';
import SQL from '@assets/icons/software_specializations/sql.svg?react';
import TTN from '@assets/icons/software_specializations/ttn.svg?react';
import VEDirect from '@assets/icons/software_specializations/ve_direct.svg?react';
import VeRegs from '@assets/icons/software_specializations/ve_regs.svg?react';
import VenusOS from '@assets/icons/software_specializations/venus_os.svg?react';
import VRM from '@assets/icons/software_specializations/vrm.svg?react';
import Webservices from '@assets/icons/software_specializations/webservices.svg?react';
import Windows from '@assets/icons/software_specializations/windows.svg?react';
import WireGuard from '@assets/icons/software_specializations/wire_guard.svg?react';
import Wireless from '@assets/icons/software_specializations/wireless.svg?react';

export const getSpecializationFromSlug = (slug: TSoftwareSpecialization) => {
    switch (slug) {
        case 'node-red':
            return { icon: NodeRed, title: 'Node-RED' };
        case 'vrm-api':
            return { icon: VRM, title: 'VRM API' };
        case 'grafana':
            return { icon: Grafana, title: 'Grafana' };
        case 'mqtt':
            return { icon: MQTT, title: 'MQTT' };
        case 'venus-os':
            return { icon: VenusOS, title: 'Venus OS' };
        case 'can-modbus-plc':
            return { icon: Can, title: 'CAN/Modbus/PLC' };
        case 'ignition-iot':
            return { icon: Ignition, title: 'Ignition IOT' };
        case 'home-assistant':
            return { icon: HomeAssistant, title: 'Home Assistant' };
        case 'can-modbus':
            return { icon: Can, title: 'CAN/Modbus' };
        case 'nmea-to-victron':
            return { icon: NmeaToVictron, title: 'NMEA to Victron' };
        case 'configuration-commissioning':
            return { icon: Commissioning, title: 'Configuration/commissioning' };
        case 'plc-modbus':
            return { icon: PLC, title: 'PLC - Modbus' };
        case 'modbus':
            return { icon: Modbus, title: 'Modbus' };
        case 'php':
            return { icon: PHP, title: 'PHP' };
        case 'python':
            return { icon: Python, title: 'Python' };
        case 'c-plus-plus':
            return { icon: CPlusPlus, title: 'C++' };
        case 'c-sharp':
            return { icon: CSharp, title: 'C#' };
        case 'mysql':
            return { icon: MySQL, title: 'MySQL' };
        case 'ai':
            return { icon: AI, title: 'AI' };
        case 'machine-learning':
            return { icon: MachineLearning, title: 'Machine Learning' };
        case 'ttn':
            return { icon: TTN, title: 'TTN' };
        case 'marine-application':
            return { icon: MarineApplication, title: 'Marine Application' };
        case 'windows':
            return { icon: Windows, title: 'Windows' };
        case 'javascript':
            return { icon: Javascript, title: 'JavaScript' };
        case 'sql':
            return { icon: SQL, title: 'SQL' };
        case 'arduino':
            return { icon: Arduino, title: 'Arduino' };
        case 'reactjs':
            return { icon: Reactjs, title: 'ReactJS' };
        case 'postgresql':
            return { icon: Postgresql, title: 'PostgreSQL' };
        case 'docker':
            return { icon: Docker, title: 'Docker' };
        case 'nginx':
            return { icon: Nginx, title: 'Nginx' };
        case 've-direct':
            return { icon: VEDirect, title: 'VE.Direct' };
        case 'proxmox':
            return { icon: Proxmox, title: 'Proxmox' };
        case 'milestone-xprotect':
            return { icon: Milestone, title: 'Milestone XProtect' };
        case 'iobroker':
            return { icon: IoBroker, title: 'ioBroker' };
        case 'influx':
            return { icon: Influx, title: 'Influx' };
        case 'rvc':
            return { icon: RVC, title: 'RVC' };
        case 'nmea-ve-regs':
            return { icon: VeRegs, title: 'NMEA/VE REGS' };
        case 'scada':
            return { icon: Scada, title: 'SCADA' };
        case 'canbus':
            return { icon: CANBus, title: 'CANbus' };
        case 'wireless':
            return { icon: Wireless, title: 'Wireless' };
        case 'lora':
            return { icon: LoRa, title: 'LoRa' };
        case 'wireguard':
            return { icon: WireGuard, title: 'WireGuard' };
        case 'raspberry-pi':
            return { icon: RaspberryPi, title: 'Raspberry Pi' };
        case 'microcontrollers':
            return { icon: Microcontrollers, title: 'Microcontrollers' };
        case 'webservices':
            return { icon: Webservices, title: 'Webservices' };
        case 'iot':
            return { icon: IoT, title: 'IoT' };
        case 'plc':
            return { icon: PLC, title: 'PLC' };
        case 've_direct': {
            return { icon: VEDirect, title: 'VE.Direct' };
        }
        case 've_regs': {
            return { icon: VeRegs, title: 'NMEA/VE REGS' };
        }
        default:
            return { icon: Default, title: slug };
    }
};

export const groupByCityName = (integrators: ISoftwareIntegratorDto[]): Record<string, ISoftwareIntegratorDto[]> => {
    return integrators.reduce((acc, integrator) => {
        const cityName = integrator.city;

        if (!acc[cityName]) {
            acc[cityName] = [];
        }

        acc[cityName].push(integrator);
        return acc;
    }, {} as Record<string, ISoftwareIntegratorDto[]>);
};
